// Add this code to your theme's JavaScript file
document.addEventListener('DOMContentLoaded', function () {
    const loadMoreButton = document.getElementById('load-more-button');
    const popularPosts = document.getElementById('popularPosts');
    if (popularPosts) {
        const childElements = popularPosts.querySelectorAll('.popularPost');
        let postsLimit = 4; // Initial limit
        const loadMoreStep = 4; // Number of posts to load on each click;\
        console.log(childElements);
        function showLimitPost(limit) {
            console.log(limit);
            childElements.forEach((childElement) => {
                if (childElement.classList.contains('hidden')) {
                    childElement.classList.remove('hidden');
                }
            });
            if (childElements.length > limit) {
                for (let i = limit; i < childElements.length; i++) {
                    childElements[i].classList.add('hidden');
                }
            }
            if (childElements.length <= postsLimit) {
                loadMoreButton.style.display = 'none'; // Hide the button if no more posts to load
            }
        }
        showLimitPost(postsLimit);
        loadMoreButton.addEventListener('click', function () {
            postsLimit += loadMoreStep; // Increase the limit
            showLimitPost(postsLimit);
        });
    }
});
